 
const mediaCache = new Map();

const isMediaUrl = (value) =>
    typeof value === "string" && value.includes("/api/media"); 

// Convert protected media API URL to Blob URL
export async function getProtectedMediaUrl(mediaUrl) {
    if (!mediaUrl) return null;

    if (!isMediaUrl(mediaUrl)) {
        return mediaUrl;
    }

    // Don't call same media API again
    if (mediaCache.has(mediaUrl)) {
        console.log("🟢 MEDIA CACHE HIT");
        return mediaCache.get(mediaUrl);
    }

    const startTime = performance.now();

    console.log("🔵 MEDIA API START:", mediaUrl);

    try {
        const response = await fetch(mediaUrl, {
            method: "GET",
            headers: {
               Authorization: `${process.env.REACT_APP_API_IMAGES_KEY}`,
            },
        });

        const apiTime = performance.now() - startTime;

        console.log(
            `⏱️ MEDIA API RESPONSE: ${apiTime.toFixed(2)} ms`
        );

        if (!response.ok) {
            throw new Error(
                `Media request failed: ${response.status} ${response.statusText}`
            );
        }

        const blobStartTime = performance.now();

        const blob = await response.blob();

        const blobTime = performance.now() - blobStartTime;

        console.log(
            `⏱️ BLOB CONVERSION: ${blobTime.toFixed(2)} ms`
        );

        const blobUrl = URL.createObjectURL(blob);

        const totalTime = performance.now() - startTime;

        console.log(
            `✅ MEDIA COMPLETE: ${totalTime.toFixed(2)} ms`
        );

        mediaCache.set(mediaUrl, blobUrl);

        return blobUrl;

    } catch (error) {
        const totalTime = performance.now() - startTime;

        console.error(
            `❌ MEDIA FAILED after ${totalTime.toFixed(2)} ms`,
            mediaUrl,
            error
        );

        return null;
    }
}


// Convert all media URLs inside API response
export async function convertMediaUrls(data) {
    const startTime = performance.now();

    let mediaCount = 0;

    const findMediaUrls = (value) => {
        if (typeof value === "string") {
            if (isMediaUrl(value)) {
                mediaCount++;
            }
            return;
        }

        if (Array.isArray(value)) {
            value.forEach(findMediaUrls);
            return;
        }

        if (value && typeof value === "object") {
            Object.values(value).forEach(findMediaUrls);
        }
    };

    findMediaUrls(data);

    console.log("======================================");
    console.log("🚀 MEDIA CONVERSION START");
    console.log("🖼️ TOTAL MEDIA URLs:", mediaCount);
    console.log("======================================");

    const convert = async (value) => {

        if (isMediaUrl(value)) {
            return getProtectedMediaUrl(value);
        }

        if (Array.isArray(value)) {
            return Promise.all(value.map(convert));
        }

        if (value && typeof value === "object") {

            const entries = await Promise.all(
                Object.entries(value).map(
                    async ([key, val]) => [
                        key,
                        await convert(val),
                    ]
                )
            );

            return Object.fromEntries(entries);
        }

        return value;
    };

    const convertedData = await convert(data);

    const totalTime = performance.now() - startTime;

    console.log("======================================");
    console.log("🏁 COMPLETE RESPONSE READY");
    console.log("🖼️ TOTAL MEDIA URLs:", mediaCount);
    console.log(
        `⏱️ TOTAL CONVERSION TIME: ${totalTime.toFixed(2)} ms`
    );
    console.log(
        `⏱️ TOTAL CONVERSION TIME: ${(totalTime / 1000).toFixed(2)} seconds`
    );
    console.log("======================================");

    return convertedData;
};


export function clearMediaCache() {
    mediaCache.forEach((blobUrl) => {
        if (
            typeof blobUrl === "string" &&
            blobUrl.startsWith("blob:")
        ) {
            URL.revokeObjectURL(blobUrl);
        }
    });

    mediaCache.clear();
}